import React from "react";
import { footerLinks } from "../../utils/dummyData";
import FooterLink from "../FooterLink";
import SectionWrapper from "../SectionWrapper";
import {
  Box,
  Contact,
  Copyright,
  FooterContent,
  Icon,
  Input,
  InputBox,
  Logo,
  Paragraph,
  SocialContainer,
  Span,
  StyledFooter,
  Text,
} from "./Footer.styles";

const Footer = () => {
  return (
    <StyledFooter>
      <SectionWrapper bgColor="#eeeffb" padding="5rem 10px">
        <FooterContent>
          <Contact>
            <Logo>Hekto</Logo>
            <InputBox>
              <Input type="email" placeholder="Enter email address" />
              <Box>Signup</Box>
            </InputBox>
            <Paragraph>
              Contact Info <br />
              17 Princess Road, London, Greater London NW1 8JR, UK
            </Paragraph>
          </Contact>

          {footerLinks.map(link => (
            <FooterLink key={link.id} {...link} />
          ))}
        </FooterContent>
      </SectionWrapper>
      <SectionWrapper bgColor="#e7e4f8" padding="10px 0">
        <Copyright>
          <Text>© Webecy - All Rights Reserved</Text>
          <SocialContainer>
            <Span>
              <Icon src="/svgs/facebook.svg" />
            </Span>
            <Span>
              <Icon src="/svgs/instagram.svg" />
            </Span>
            <Span>
              <Icon src="/svgs/twitter.svg" />
            </Span>
          </SocialContainer>
        </Copyright>
      </SectionWrapper>
    </StyledFooter>
  );
};

export default Footer;
